// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__Jwwib","modal":"Modal_modal__scwdS","appear":"Modal_appear__s7NP+","footer":"Modal_footer__udR47"};